import { Component, computed, effect, input, signal } from '@angular/core';

@Component({
  selector: 'app-loading-page',
  standalone: true,
  imports: [],
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.scss'],
})
export class LoadingPageComponent {
  readonly title     = input('PARTNER CORE');
  readonly logoSrc   = input<string | null>(null);
  readonly isLoading = input(true);
  /** admin = Partner Core; store = tienda p├║blica */
  readonly variant   = input<'admin' | 'store'>('admin');

  protected readonly fadeOut = signal(false);
  protected readonly logoBroken = signal(false);

  protected readonly monogram = computed(() => {
    const t = (this.title() || '').trim();
    if (!t) return 'ÔÇó';
    return t.charAt(0).toUpperCase();
  });

  protected readonly showLogoImage = computed(() => {
    const src = this.logoSrc()?.trim();
    return !!src && !this.logoBroken();
  });

  constructor() {
    effect(() => {
      this.fadeOut.set(!this.isLoading());
    });
    effect(() => {
      this.logoSrc();
      this.logoBroken.set(false);
    });
  }

  onLogoError(): void {
    this.logoBroken.set(true);
  }
}
